{
    "WebexAuth_UserIntro": "Hi **{}**,",
    "WebexAuth_UserIntro_2": "CX Analytics is requesting access to your Webex Calling Tenant",
    "WebexAuth_AdminConsent": "Grant Admin Consent",
    "WebexAuth_Authorise": "Authorize",
    "WebexAuth_ConsentedMessage": "Admin Consent granted, please click Authorize to continue",
    "WebexAuth_AuthorisedMessage": "Authorization granted",
    "WebexAuth_Decline": "Decline",
    "WebexAuth_Error_Unknown": "An unrecognised error has occurred. Please try again. If the problem persists, please contact your system administrator.",
    "NAME": "WebexAuthLanguage"
}
